// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import './_product-recommendations.scss';

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
  swiperEl.slides.forEach(function(slide, index) {
      let slideLink = slide.querySelector('a');
      slideLink.addEventListener('focus', function(e) {
          swiperEl.slideTo(index);
      })
  });
}

// -------------------------------------
// Product Slider
// -------------------------------------

function product_slider() {
  $(".product-recommendations-slider").each(function (index, element) {
    var $this = $(this);

    // Generate unique class for each product list slider
    $this.addClass("product-slider-instance-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.product-slider').find(".swiper-button-prev").addClass("product-slider-btn-prev-" + index);
    $this.parents('.product-slider').find(".swiper-button-next").addClass("product-slider-btn-next-" + index);

    var swiper = new Swiper(".product-slider-instance-" + index, {
      // Optional parameters
      modules: [Navigation, Pagination, A11y],
      slidesPerView: 2,
      spaceBetween: 13,
      observer: true,
      observeParents: true,
      a11y: false,
      watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      breakpoints: {
        // when window width is >= 680ppx
        680: {
          slidesPerView: 4,
          spaceBetween: 36
        }
      },

      // // Navigation arrows
      navigation: {
        nextEl: ".product-slider-btn-next-" + index,
        prevEl: ".product-slider-btn-prev-" + index
      },

      // Pagination
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true'
      },
    });

    swiper.slides.forEach(function (slide, index) {
      let slideLink = slide.querySelector('a');
      slideLink.addEventListener('focus', function (e) {
        swiper.slideTo(index);
      })
    });
  });
}

$(document).ready(function(){
  if( $(".product-recommendations--tags").length ){
    product_slider();
  }
});


// -------------------------------------
// Dynamic Recommendations
// -------------------------------------
$(document).ready(function(){

  var loadProductRecommendationsIntoSection = function() {
       // Look for an element with class 'product-recommendations'
       var productRecommendationsSection = document.querySelector(".product-recommendations");
       if (productRecommendationsSection === null) { return; }

       // Read product id from data attribute
       var productId = productRecommendationsSection.dataset.productId;

       // Read limit from data attribute
       var limit = productRecommendationsSection.dataset.limit;
      var productType = productRecommendationsSection.dataset.productType;

       // Build request URL
       var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;

       // Create request and submit it using Ajax
       var request = new XMLHttpRequest();
       request.open("GET", requestUrl);
       request.onload = function() {
         if (request.status >= 200 && request.status < 300) {
           var container = document.createElement("div");
           container.innerHTML = request.response;
           productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
           //load the product slider scripts
           product_slider();
         }
       };
       request.send();
  };

   // If your section has theme settings, the theme editor
   // reloads the section as you edit those settings. When that happens, the
   // recommendations need to be fetched again.
   // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
   // document.addEventListener("shopify:section:load", function(event) {
   //   if (event.detail.sectionId === "product-recommendations") {
   //     loadProductRecommendationsIntoSection();
   //   }
   // });

   // Fetching the recommendations on page load
   loadProductRecommendationsIntoSection();
});
